import { Check, Minus } from 'lucide-react';
import { cn } from '@/lib/utils';
import './securityMethods.css';

/** Text always carries the state; color and the check are supporting cues. */
export function SecurityMethodStatus({
  active,
  label,
}: {
  active: boolean;
  label: string;
}) {
  const Icon = active ? Check : Minus;
  return (
    <span className={cn('security-method-status', active && 'is-active')}>
      <Icon key={String(active)} aria-hidden="true" />
      {label}
    </span>
  );
}
